import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RedirectService } from '../services/redirect.service';
import { localizedURL } from '../helpers/navigation.helper';
import { isSupportedLanguage } from '../services/translation.service';
import { StorageService } from '../services/storage.service';

export const authGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const tokenService = inject(TokenService);
  const storageService = inject(StorageService);
  const router = inject(Router);
  const redirectService = inject(RedirectService);
  const savedLang = storageService.getLanguage();
  const lang = savedLang && isSupportedLanguage(savedLang) ? savedLang : 'en';

  if (tokenService.hasTokens()) {
    return true;
  }

  // Get the full URL from current router state
  const fullUrl = state.url;

  const roomRegex = /^\/playarea\/room\/\d+\/join\/\w+$/;

  // Save URL without leading slash
  if (fullUrl && typeof fullUrl === 'string' && roomRegex.test(fullUrl)) {
    redirectService.setRedirectUrl(fullUrl.substring(1));
  }

  const loginUrl = localizedURL('/auth/login', lang);

  // console.log('🌐 Redirecting to login page with language:', lang, loginUrl);

  // Redirect to login page
  router.navigate([loginUrl]);
  return false;
};
